<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Mq2TkS/tc-custom/9781649796349.jpg?1705540911371" alt="This image is the cover for the book Fairy and Gnome Tales – Book One"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fairy and Gnome Tales – Book One
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;color:black;'>Ah! Welcome! I have been waiting for you! You have found a path that leads to a secret place I know deep in the great Northwoods, where magical trees whisper tales of fairies and gnomes. Open the story and begin your journey. In this first tale, come meet the Grandfather Tree, who always has a story to tell, and Joshua, a special gnome who learns the importance of teamwork and cooperation.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Schmidig
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;color:black;'>Jennifer Schmidig is living her dream of making a difference in children&rsquo;s lives. She has been teaching elementary students for 24 years, and currently teaches 6th grade science.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;color:black;'>She lives with her husband, son, and a few energetic kitties in Northern Wisconsin, where the woods are still deep, the lakes abound, and the eagles soar.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;color:black;'>In her free time, she enjoys the outdoors and writing stories to entertain her children and grandchildren.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?690d9ddb